export const documentContentStoreMixin = {
  inject: {
    contentStoreModule: {
      from: 'contentStoreModule',
      default: 'reportContent'
    }
  },
  methods: {
    contentGetter (name) {
      return this.$store.getters[this.contentStoreModule + '/' + name]
    },
    contentDispatch (name, payload) {
      return this.$store.dispatch(this.contentStoreModule + '/' + name, payload)
    }
  }
}
